<template>
		<section class="cases">
			<div class="container section-active">
				<div class="row">
					<div class="col-xs-12 col-sm-4 col-md-4 x-gundong">
						<div class="casesNav" v-for="(item, index) in casesList" :key="index" 
						:class="casesIndex == index ? 'casesNav-active':''" @click="swichToCases(index)">
							{{item}}
						</div>
					</div>
					<div class="col-xs-12 col-sm-8 col-md-8">
						<img src="../assets/img/product/case.png" alt="" class="img-responsive case-img">
						<div v-if="casesIndex==0">
							<p class="cases-content">互联网科技法律事务是高思顺应现代科技发展，与时俱进发展的业务之一。高思的律师在互联网科技领域具有丰富的经验，公司客户为互联网行业的高新技术公司，为公司客户提供了切实可行的法律方案，有效解决科技公司在发展中面临的法律问题。我们致力于尽快解决公司客户面临的法律问题，为其提供全方位的法律服务和解决方案，避免其因寻求不同帮助而浪费资源。 </p>
							<p class="cases-font-weight">我们在互联网科技法律领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>互联网科技公司设立、并购、注销、破产；</li>  
									<li>互联网科技公司的数据安全及隐私保护；</li>
									<li>互联网科技公司常年法律顾问；</li> 
									<li>互联网科技公司运营合规审查；</li>
									<li>互联网科技公司商标、软件著作权、专利、域名、商业秘密等知识产权保护；</li>
									<li>互联网科技公司争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>为北京某高新技术公司从公司设立到成长全程提供法律服务，结合欧盟隐私法律及中国政策，为公司建立一整套完备的数据安全保护体系，保障公司合法合规；</li>  
									<li>为中国第一家青少年体能及人工智能研究中心提供软件著作权、专利申请全程知识产权保护。</li>
								</ul>
							</p>
						</div>
						<div v-if="casesIndex==1">
							<p class="cases-content">矿业及能源是我们的核心业务之一。我们的律师熟悉中国政府在矿业方面的法律法规及政策，在矿业权的申请、转让、开采、评估、设立矿业公司等方面具有丰富经验，为上百个矿业权项目提供过咨询、前期调查、谈判、申请、转让等法律服务，并涉及矿业权的争议解决和刑事案件，矿产种类包括金、铜、煤、风能、稀土、钾盐等。</p>
							<p class="cases-font-weight">我们在矿业领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>矿业权申请、变更、转让及相关政府备案、审批；</li> 
									<li>矿业权转让前期调查，转让谈判，合同条款的设计、拟定、签订；</li> 
									<li>矿业勘探、开发公司设立，勘查单位的选择与勘查合同的签署；</li>
									<li>矿业公司运营法律风险审查；</li> 
									<li>争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>代理北京某公司在新疆和硕县设立探矿权；</li>
									<li>代为客户管理新疆、陕西矿权；</li>
									<li>代理客户收购新疆拜城县铌钽矿；</li>
									<li>负责北京某公司湖北省钾盐矿权项目的法律工作；</li>
									<li>代理北京某公司收购位于新疆、贵州、广西、吉林数十个探矿权；</li>
									<li>代理北京某公司谈判解决与新疆某公司八十六个探矿权转让纠纷。</li>
								</ul>
							</p>
						</div>
						<div v-if="casesIndex==2">
							<p class="cases-content">知识产权包括著作权、商标、专利、商业秘密、不正当竞争等多项法律业务。我们的律师不仅接受过优质的知识产权法学教育，还在著作权取得、商标申请、商业秘密保护、不正当竞争，以及知识产权诉讼等实务领域具有多年经验，可以为客户提供优质的法律服务。</p>
							<p class="cases-font-weight">我们在知识产权领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>商标申请及范围；</li> 
									<li>知识产权保护方案；</li> 
									<li>不正当竞争行为审查；</li> 
									<li>争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>为北京某知名电子市场申请注册商标；</li>
									<li>为北京某培训机构申请注册商标；</li>
									<li>为北京某医疗设备公司计算机软件著作权确权、侵权纠纷提供诉讼代理服务；</li>
									<li>为全国某知名中药生产企业技术秘密转让合同提供法律服务；</li>
									<li>为刘某与北京某出版社著作权侵权纠纷提供诉讼代理服务；</li>
									<li>为北京某公司诉某营业部不正当竞争提供诉讼代理服务；</li>
									<li>为某国际知名连锁餐饮企业商标使用权提供法律服务。</li>
								</ul>
							</p>
						</div>
						<div v-if="casesIndex==3">
							<p class="cases-content">公司无论大小，均会具有投资意愿，亦会产生融资需求。我们在该领域具有丰富的经验，可以通过提供专业法律服务，保障客户投、融资需求的实现。</p>
							<p class="cases-font-weight">我们在投/融资领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>投资前期风险调查；</li>  
									<li>投资谈判；</li>
									<li>投资合同起草、修改、签订；</li>
									<li>资产管理；</li>
									<li>投资情况跟踪；</li> 
									<li>项目融资；</li> 
									<li>争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>为北京某公司投资武汉经营性公墓提供法律服务；</li>
									<li>为北京某公司投资蓄电池生产项目提供法律服务；</li>
									<li>为北京某公司收购北京某学校提供法律服务；</li>
									<li>为北京某公司陕西矿权项目合作开发融资项目提供法律服务；</li>
									<li>为北京某公司新疆矿权合作项目提供法律服务。</li>
								</ul>
							</p>
						</div>
						<div v-if="casesIndex==4">
							<p class="cases-content">合同是确定各主体之间权利义务关系的重要载体。无论公司、个人还是其他组织，在日常工作生活中均会涉及各类合同。合同是否合法、是否完备，直接决定了各主体之间法律关系及权利义务，直至最终结果。</p>
							<p class="cases-content">我们的律师熟悉合同法律法规及相关政策、规章，在合同领域具有多年的实践经验，并通过不断学习提高处理各类合同的能力。我们可以为客户提供合同方面的专业法律服务，努力保护客户利益。</p>
							<p class="cases-font-weight">我们在合同领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>合同起草、审查、修订；</li>  
									<li>签约前法律风险调查；</li> 
									<li>合同主体审查；</li> 
									<li>履约情况跟踪；</li> 
									<li>争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>为某集团公司矿权收购提供合同专项法律服务；</li>        
									<li>为某日资化工企业股权转让提供合同专项法律服务；</li>
									<li>为某集团公司项目建设工程提供合同专项法律服务；</li>
									<li>为某电池生产企业产品全国营销提供合同专项法律服务；</li> 
									<li>为某公司电影制作项目提供合同专项法律服务。</li>
								</ul>
							</p>
						</div>
						<div v-if="casesIndex==5">
							<p class="cases-content">民事商活动中，发生争议并寻求解决是十分普遍但又非常重要的事务。我们认为并相信，只有具备较强综合业务能力的情况下，才能在争议发生时为客户提供优质法律服务。因此，争议解决是高思重要业务之一。在这方面，我们熟悉法律，谈判、庭审经验丰富，并具有处理复杂问题的专业能力。实际工作中，我们既有通过诉讼否决兼并，亦有通过仲裁为客户挽回巨额损失，更有通过谈判避免重大损失发生的案例。</p>
							<p class="cases-font-weight">我们在争议解决领域提供的法律服务有：</p>
							<p class="cases-content">
								<ul>
									<li>争议解决方案评估及确定；</li>    
									<li>诉讼；</li>   
									<li>仲裁；</li>   
									<li>谈判；</li>
									<li>争议解决。</li>
								</ul>
							</p>
							<p class="cases-font-weight">经典案例：</p>
							<p class="cases-content">
								<ul>
									<li>代理黑龙江某乳品企业诉某丹麦企业、某澳大利亚企业合同纠纷仲裁案；</li>
									<li>代理北京某集团公司诉某拍卖公司拍卖合同纠纷诉讼案；</li>
									<li>代理法国某石油公司应诉产品质量纠纷案；</li>
									<li>代理新疆某公司诉其高级管理人员损害股东利益责任纠纷案；</li>
									<li>代理北京某研究所诉某集团公司兼并纠纷案；</li>
									<li>为黑龙江某薯业公司的境内外谈判、仲裁和诉讼提供法律服务，所代理案件均取得胜诉，并执行回款。</li>
								</ul>
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	data () {
		return {
			casesIndex: 0,
			casesList: ['互联网科技法律事务','矿业·能源','知识产权','投/融资','合同','争议解决']
		}
	},
	methods: {
		swichToCases (index) {
			this.casesIndex = index;
		}
	}
}
</script>

<style scoped>
@import url("../assets/css/common.css");
@import url("../assets/css/product.css");
</style>


// WEBPACK FOOTER //
// src/components/cases.vue